<template>
  <div id="mainWrapper" class="main-wrapper main-wrapper-1">
    <!-- warn modal -->
    <div
      id="warnDialog"
      class="modal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Session Timeout</h5>
          </div>
          <div class="modal-body">
            <p>Your session is about to expire. Click OK to stay connect.</p>
            <p>{{ sessionErrorMsg }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="extendSession">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!-- /warn modal -->
    <!-- timeout modal -->
    <div
      id="timeoutDialog"
      class="modal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Session Timeout</h5>
          </div>
          <div class="modal-body">
            <p>Your session has been expired. Click OK to reconnect again.</p>
            <p>{{ sessionErrorMsg }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="relogin">OK</button>
          </div>
        </div>
      </div>
    </div>
    <template v-if="isInit">
      <Message />
      <LinkHandling />
      <Navbar></Navbar>
      <Sidebar :stisla="stisla" ref="sideBar"></Sidebar>
      <router-view></router-view>
      <MyFooter></MyFooter>
    </template>
  </div>
</template>
<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import Message from "@/components/Message.vue";
import LinkHandling from "@/components/LinkHandling.vue";

import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import MyFooter from "@/components/MyFooter.vue";
//import Dashboard from "@/views/contents/Dashboard.vue";
import Stisla from "@/assets/js/stisla";
import api from "@/api";
import { mapGetters, mapActions } from 'vuex';
import helper from "@/vueHelper"

export default {
  name: "app",
  components: {
    Navbar,
    Sidebar,
    MyFooter,
    //Dashboard,
    Message,
    LinkHandling
  },
  data() {
    return {
      stisla: null,
      isInit: false,
      sessionErrorMsg: null
    };
  },
  computed:{
    ...mapGetters(["getSidLogin"])
  },
  methods: {
    ...mapActions(["actionResetTimeout"]),
    async load() {
      this.isInit = true;
      let stisla = new Stisla();
      stisla.init();
      this.stisla = stisla;
    },
    extendSession() {
      api.request(
        this,
        "post",
        "/system/extendSession",
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {}
        },
        function(r) {
          // session extended, close timeout dialog
          $("#warnDialog").modal("hide");

          // reset timeout
          this.actionResetTimeout();
        },
        function(r) {
          this.sessionErrorMsg = this.$store.state.errorMsg;
        }
      );
    },
    relogin() {
      // Hide all modal
      $(".modal").modal("hide");

      if (this.getSidLogin) {
        this.clearSession();
        window.close();
      } else {
        this.$router.replace(
          "/login?redirect=" + this.$router.currentRoute.fullPath
        );
      }
    },
    clearSession() {
      this.$store.commit("setUser", {});
      this.$store.commit("setToken", null);
      this.$store.commit("setSidLogin", null);

      // Support refresh
      if (window.localStorage) {
        // window.localStorage.clear();
        helper.removeStorageItem("ccrs_user");
        helper.removeStorageItem("ccrs_token");
      }

      // Clear all cookies
      window.clearCookie();
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style>
.navbar-bg {
  color: #4585ce !important;
}

.section .section-title:before {
  background-color: #4585ce !important;
}
.section-title {
  color: #4585ce !important;
}

.card-stats-item-count {
  color: #4585ce;
  cursor: pointer;
}
.fa-number-1:before {
  content: "1";
}
.fa-number-2:before {
  content: "2";
}
.fa-number-3:before {
  content: "3";
}
</style>

